<template>
  <div>
    <v-dialog v-model="showModal" max-width="400px" v-if="responseData">
      <v-card>
        <v-card-title style="font-weight: bold; font-size: 16px; margin-bottom: 12px;">
          Cep telefonunuza bildirim gönderildi. <br> Burada yazan kodu giriniz.
        </v-card-title>
        <v-card-text>
          <p>{{ responseData.phone }} numarası için WhatsApp onay kodu</p>
          <p style="font-weight: bold; color: #4caf50; font-size: 21px;">{{ responseData.code }}</p>
          <h2 class="mt-3" style="font-weight: normal;">
            <vue-countdown style="font-size: 16px;" key="countdownKey" @end="onCountdownEnd" :time="30 * 1000" v-slot="{ seconds }">
              Kalan Zaman: {{ seconds }}
            </vue-countdown>
          </h2>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="showModal = false">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-else></div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import VueCountdown from '@chenfengyuan/vue-countdown';

export default {
  components: { VueCountdown },
  props: {
    responseData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      countdownKey: 0,
    };
  },
  computed: {
    showModal: {
      get() {
        return this.$store.state.showWhatsappPhoneCodeModal;
      },
      set(value) {
        this.$store.commit('setShowWhatsappPhoneCodeModal', value);
      },
    },
  },
  watch: {
    responseData: {
      handler(newVal) {
        if (newVal && newVal.code && newVal.reg_id) {
          this.showModal = true;
          this.startCountdown(30, newVal.reg_id);
        } else {
          // Veriler eksik veya hatalı geldiğinde yapılacak işlem
          console.error("Gerekli veriler eksik.");
        }
      },
      immediate: true,
    },
  },
  methods: {
    setDialog(value) {
      this.$store.commit('updateWhatsappQrModal', value);
      window.location.reload();
    },
    checkDeviceActive(reg_id) {
      Vue.axios({
        url: `${this.$store.getters.apiEndpoint}whatsapp/check-device`,
        data: {
          reg_id: reg_id
        },
        method: 'POST',
        statusCode: 500,
        responseType: 'JSON',
      }).then((res) => {
        this.account = res.data.data.account_status;
        if (res.data.data.device) {
          this.localDevice = {
            status: res.data.data.device,
            sender: res.data.data.device.sender,
            credit: res.data.data.device.credit,
          };
          clearInterval(this.countdownInterval);
          this.setDialog(false); // Bu satırı ekleyin. Modalı kapatır.
        } else {
          this.localFromRemove = true;
          this.localDevice = { status: false, sender: null, credit: 0 };
        }
      }).catch(() => {
        this.localFromRemove = true;
      })
          .finally(() => {
            this.loader = false;
          });
    },
    startCountdown(seconds, reg_id) {
      var counter = seconds;
      this.countdownInterval = setInterval(() => {
        counter--;
        this.checkDeviceActive(reg_id);

        if (counter < 0) {
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },
    onCountdownEnd() {
      this.$store.commit('setShowWhatsappPhoneCodeModal', false);
      window.location.reload();
    },
  },
};
</script>